<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='月度奖金发放报表' url='/report/achievement/monthly'></SearchTitle>
      <div class="m-portlet__body">
        <el-tabs v-model="active" type="card" @tab-click="handleClick">
          <el-tab-pane label="学员" name="first">
            <div class="m-form m-form--label-align-right">
              <SearchNormalText v-model='conditionStu.truename' label='姓名'></SearchNormalText>
              <div style="float: left;margin-top: 10px;">
                <div class="m-form__group m-form__group--inline">
                  <div class="m-form__label">
                    <label style="width: 100px;text-align:right;">考核月份：</label>
                  </div>
                  <div class="m-form__control">
                    <el-date-picker v-model="conditionStu.assessmentmonth" type="month" placeholder="考核月份" value-format="yyyy-MM">
                    </el-date-picker>
                  </div>
                </div>
                <div class="d-md-none m--margin-bottom-10"></div>
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
              <el-button type="primary" icon="el-icon-search" @click="StuSearch">查询</el-button>
              <el-button type="primary" icon="el-icon-download" @click="StuOut">导出</el-button>
            </div>
            <!--end: Search Form -->
            <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
              <!--begin: Datatable -->
              <div v-html="tabStuAchievement">
              </div>
              <!--end: Datatable -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="带教老师" name="second">
            <div class="m-form m-form--label-align-right">
              <SearchNormalText v-model='conditionTeach.truename' label='姓名'></SearchNormalText>
              <div style="float: left;margin-top: 10px;">
                <div class="m-form__group m-form__group--inline">
                  <div class="m-form__label">
                    <label style="width: 100px;text-align:right;">考核月份：</label>
                  </div>
                  <div class="m-form__control">
                    <el-date-picker v-model="conditionTeach.assessmentmonth" type="month" placeholder="考核月份" value-format="yyyy-MM">
                    </el-date-picker>
                  </div>
                </div>
                <div class="d-md-none m--margin-bottom-10"></div>
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
              <el-button type="primary" icon="el-icon-search" @click="TeachSearch">查询</el-button>
              <el-button type="primary" icon="el-icon-download" @click="TeachOut">导出</el-button>
            </div>
            <!--end: Search Form -->
            <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
              <!--begin: Datatable -->
              <div v-html="tabTeachAchievement">
              </div>
              <!--end: Datatable -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: 'first',
      conditionStu: {
        token: '',
        truename: '',
        assessmentmonth: ''
      },
      conditionTeach: {
        token: '',
        truename: '',
        assessmentmonth: ''
      },
      tabStuAchievement: null,
      tabTeachAchievement: null
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    StuSearch: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuReportList', this.conditionStu)
        .then(res => {
          if (res.data.Code === 0) {
            this.tabStuAchievement = res.data.Data
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          this.tabStuAchievement = null
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    },
    TeachSearch: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachReportList', this.conditionTeach)
        .then(res => {
          if (res.data.Code === 0) {
            this.tabTeachAchievement = res.data.Data
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          this.tabTeachAchievement = null
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    },
    StuOut: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuReportListOut', this.conditionStu)
        .then(res => {
          if (res.data.Code === 0) {
            var filename = res.data.Data
            var url = this.$utils.Url.zpgl + '/doc/' + filename
            window.open(url)
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '导出失败',
            type: 'error'
          })
        })
    },
    TeachOut: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachReportListOut', this.conditionTeach)
        .then(res => {
          if (res.data.Code === 0) {
            var filename = res.data.Data
            var url = this.$utils.Url.zpgl + '/doc/' + filename
            window.open(url)
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '导出失败',
            type: 'error'
          })
        })
    }
  },
  mounted: function () {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    this.conditionStu.assessmentmonth = year + '-' + month
    this.conditionTeach.assessmentmonth = year + '-' + month
    this.conditionStu.token = sessionStorage.getItem('token')
    this.conditionTeach.token = sessionStorage.getItem('token')
    this.StuSearch()
    this.TeachSearch()
  }
}
</script>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>
